import { ProductQuoteRequestItem } from '@typesApp/ProductQuote'
import { CommerceProductQuoteRequestItem } from '@typesApp/Service'
import { isContactLensProductType, isFrameProductType } from '@utils/productTypeUtil'

export const mapCommerceProductQuoteRequest = (
  products: CommerceProductQuoteRequestItem[]
): ProductQuoteRequestItem[] => {
  return (products ?? []).map(product => {
    const {
      productType,
      quantity = 1,
      salePrice,
      retailPrice,
      serviceCategories,
      productIdentifier,
      productName,
      eye,
      groupId,
    } = product

    const isFrame = isFrameProductType(productType)
    const isContacts = isContactLensProductType(productType)

    const result: ProductQuoteRequestItem = {
      productType,
      productName,
      ecommerceId: productIdentifier,
      ecommerceIdType: 'RXC_ID',
      quantity,
      salePrice,
      retailPrice,
      eye,
      groupId,
      serviceCategories: Array.isArray(serviceCategories) && serviceCategories.length ? serviceCategories : undefined,
    }

    if (!isContacts) {
      delete result.eye

      if (!isFrame) {
        delete result.productName
      }
    }

    return result
  })
}
